import { useTheme } from "@mui/material";

/**
 * Returns a function that allows the usage of theme palette colors more easily.
 * Instead of needing to use `theme.palette.owGray.main`, one can simply
 * use `owGray` as the color string.
 */
export const useMapToTheme = () => {
  const theme = useTheme();

  const mapToTheme = (color: string) => {
    const paletteKeys = Object.keys(theme.palette);
    if (paletteKeys.includes(color)) {
      const paletteEntry = theme.palette[color as keyof typeof theme.palette];
      if (typeof paletteEntry === "object" && "main" in paletteEntry) {
        return (paletteEntry as { main: string }).main;
      }
    }
    // If the color is not a valid palette key, return it as is
    return color;
  };
  return { mapToTheme };
};
